import { useMemo } from 'react';
import { useFirestoreGeneralTwo } from '../../firebase/useFirestore';

const SessionResponsesCount = ({ sessionID, researchID }) => {
  // Pull all response docs for this session+research
  const responses = useFirestoreGeneralTwo(
    'QuestionnairesResponses',
    'SessionID',  sessionID || '',
    'ResearchID', researchID || ''
  );

  // Count unique questions 
  const uniqueQuestionsAnswered = useMemo(() => {
    if (!Array.isArray(responses) || responses.length === 0) return 0;

    const uniqueSet = new Set();

    for (const r of responses) {
      uniqueSet.add(r.FieldID);
      
    }

    return uniqueSet.size;
  }, [responses]);

  return <>{uniqueQuestionsAnswered}</>;
};

export default SessionResponsesCount;
